import { render, staticRenderFns } from "./gzhConfigList.vue?vue&type=template&id=c9bc8396&scoped=true"
import script from "./gzhConfigList.vue?vue&type=script&lang=js"
export * from "./gzhConfigList.vue?vue&type=script&lang=js"
import style0 from "./gzhConfigList.vue?vue&type=style&index=0&id=c9bc8396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bc8396",
  null
  
)

export default component.exports